import SchoolRepositories from "@repositories/school.repositories"
import { School, SchoolListQuery, SchoolType, Testimonial } from "@interfaces/school"
import { PaginationData } from "@interfaces/misc"
import { Result } from "@services/response"

export default class SchoolServices extends SchoolRepositories {
  async getSchoolList(type: SchoolType, query?: Partial<SchoolListQuery>) {
    try {
      const res = await this.getRawSchoolList(type, {
        page: query?.page ?? 1,
        limit: query?.limit ?? 12,
        ...(query?.search && { search: query?.search }),
      })

      const response = await this._getResponse<PaginationData<School>>(res)

      if (response.error) {
        return Result.fail<PaginationData<School>>()
      }

      return Result.ok<PaginationData<School>>(response.result)
    } catch (e) {
      return Result.fail<PaginationData<School>>()
    }
  }

  async getTestimonials() {
    try {
      const res = await this.getRawTestimonials()
      const response = await this._getResponse<Testimonial[]>(res)

      if (response.error) {
        return Result.fail<Testimonial[]>()
      }

      return Result.ok<Testimonial[]>(response.result)
    } catch (e) {
      return Result.fail<Testimonial[]>()
    }
  }
}
